import { render } from "./StartView.vue?vue&type=template&id=dc05dbc6&scoped=true"
import script from "./StartView.vue?vue&type=script&lang=js"
export * from "./StartView.vue?vue&type=script&lang=js"

import "./StartView.vue?vue&type=style&index=0&id=dc05dbc6&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/aethonspel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc05dbc6"]])

export default __exports__